import React from 'react'
import { Form, Header, Transition } from 'semantic-ui-react'
import { AllocationTradeFields, ApexTradeFields, AwayTradeFields } from './components'
import { ANIMATION_DURATION } from './constants'
import { tradeTypeEnumToDisplay } from './helpers'
import { TradeFormErrors, TradeFormTouched, TradeFormValues, TradeTypeEnum } from './Types'

export interface CounterPartyDetailsProps {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  handleChange: (e: React.ChangeEvent) => void
  handleBlur: (field: string) => void
  values: TradeFormValues
  touched: TradeFormTouched
  errors: TradeFormErrors
}

const CounterPartyDetails = (props: CounterPartyDetailsProps) => {
  const {
    values: { tradeType },
  } = props

  return (
    <section className={'test-counter-party-details'}>
      <Header as={'h2'}>Counterparty Details</Header>
      <p>Trade Type: {tradeTypeEnumToDisplay(tradeType)}</p>
      <Form>
        <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
          {tradeType === TradeTypeEnum.awayTrade && (
            <div>
              {/* divs needed for transitions */}
              <AwayTradeFields {...props} />
            </div>
          )}
        </Transition.Group>
        <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
          {tradeType === TradeTypeEnum.execution && (
            <div>
              <ApexTradeFields {...props} />
            </div>
          )}
        </Transition.Group>
        <Transition.Group animation={'fade down'} duration={ANIMATION_DURATION}>
          {tradeType === TradeTypeEnum.allocation && (
            <div>
              <AllocationTradeFields {...props} />
            </div>
          )}
        </Transition.Group>
      </Form>
    </section>
  )
}

export default CounterPartyDetails
